import { useMutation } from "react-query";
import downloadCollectionsListingCSV from "../services/downloadCollectionsListingCSV";

function useDownloadCollectionsListingCSV() {
  return useMutation(
    ["downloadCollectionsListingCSV"],
    downloadCollectionsListingCSV
  );
}

export default useDownloadCollectionsListingCSV;
